import request, { gql } from "graphql-request";

export const EXPORTREPORTDATA = gql`
  mutation exportScreeningData($filters: ExportFilterInput!) {
  exportScreeningData(filters: $filters) {
    success
    error
    message
    downloadUrl
  }
}
`;
